
import {defineComponent,PropType,ref,Ref,inject,computed} from "vue"
  import {Device} from "@/models/devices.interface";
  import {Message} from "@/models/message.interface";
  import {DeviceService} from "@/services/device.services";
  import {SMSMessage} from "@/models/message.interface";

  export default defineComponent({
   name: "DeviceComponent",
   props:{
      device:{
	type: Object as PropType<SMSMessage>
      }      
    },
    setup(){
      const messages:Ref<SMSMessage[]>=inject("messages_from_phone") as Ref<SMSMessage[]>;
      const title:Ref<String> = inject("origin_title") as Ref<String>;
	  const handle_click =async (phone_number:string)=>{
	    title.value=phone_number;
	  const service = new DeviceService();
	const get_messages= async()=>messages.value=  await service.getByDeviceNumber(phone_number);

	        get_messages();
      };
      const imgStatus= computed(()=>{
	 let img="../img/water-tap.png"; 
	switch(status){
	  case "unattended":
	    img="@/img/water-tap.png";
	    break;
	  case "asigned":
	    img = "img/tap.png";
	    break;
	 }
	return img;
      });
      const texto_usuario = computed((texto?:string)=>{console.log("texto usuairo",texto);  return texto==undefined? "bg-info":"bg-secondary"});
      return{handle_click, messages,imgStatus,texto_usuario};
    }
    
  });
